import styled from 'styled-components';
import { grey40 } from 'Styles/colors';
import { fontTitle } from 'Styles/fonts';

import ButtonIconOriginal from '../Icons/ButtonIcon';

export const QuantitySelector = styled.div`
  display: flex;
  flex-direction: row;
`;

export const QuantityInput = styled.input.attrs({ type: 'number' })`
  ${fontTitle(16)};
  height: 32px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${grey40};
  border-bottom: 1px solid ${grey40};
  border-left: none;
  border-right: none;
  text-align: center;
  outline: none;
`;

export const QuantityButton = styled(ButtonIconOriginal).attrs({
  variant: 'defaultLight'
})`
  background-color: ${grey40};
  min-height: 32px;
  height: 32px;
  min-width: 40px;
  width: 40px;

  &:first-of-type {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-of-type {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
